import React from "react";
import profile from "../../../assets/Profile.png";

const AvatarCard = () => {
  return (
    <div className="card shadow-lg compact bg-base-100">
      <div className="grid place-items-center py-8">
        <div className="avatar opacity-90">
          <div className="mb-8 rounded-full w-32 h-32 ring ring-primary ring-offset-base-100 ring-offset-2">
            <img src={profile} alt="Ariful Alam" />
          </div>
        </div>
        <div className="text-center mx-auto px-8">
          <h5 className="font-bold text-2xl">
            <span className="text-base-content opacity-70">
              Kartik Budhraja
            </span>
          </h5>
          <div className="mt-3 text-base-content text-opacity-60 font-mono">
            ⚡ Software Engineer | ReactJs | JavaScript | Frontend developer ⚡
          </div>
        </div>

        <a
          href="https://drive.google.com/file/d/1ly2QKrgz2MpTztTtsTSBc5aPJku182y4/view?usp=drive_link"
          className="cta-button"
          target="_blank"
          rel="noreferrer"
        >
          <span className="cta-button__icon-wrapper">
            <svg
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="cta-button__icon-svg"
              width="10"
            >
              <path
                d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                fill="currentColor"
              ></path>
            </svg>

            <svg
              viewBox="0 0 14 15"
              fill="none"
              width="10"
              xmlns="http://www.w3.org/2000/svg"
              className="cta-button__icon-svg cta-button__icon-svg--copy"
            >
              <path
                d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                fill="currentColor"
              ></path>
            </svg>
          </span>
          See Resume
        </a>
      </div>
    </div>
  );
};

export default AvatarCard;
